import Vue from 'vue';
import orderProductTransformer from './../../transformers/orderProduct';

const success = (data, id, resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(orderProductTransformer.fetch(errors));
};

export default (id, orderProduct, orderProductId, type = 'normal') => (
  new Promise((resolve, reject) => {
    let url = `/orders/${id}/products/${orderProductId}`;
    if (type === 'bulk') {
      url += '/bulk';
    }
    Vue.$http
    .put(url, orderProductTransformer.send(orderProduct))
    .then((response) => {
      success(response.data, id, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/orderProduct/update.js